import React, { useEffect } from 'react';
//import { Link, useNavigate } from 'react-router-dom';
//import { FaArrowLeftLong } from "react-icons/fa6";
import { GoTriangleUp } from 'react-icons/go';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
    const loans = [
        {
        "type": "Total Outstanding",
        "amount": "00,000"
        },
        {
        "type": "Home Loan",
        "amount": "00,000"
        },
        {
        "type": "Credit Cards",
        "amount": "00,000"
        },
        {
        "type": "Personal Loan",
        "amount": "00,000"
        },
        {
        "type": "Vehicle Loan",
        "amount": "00,000"
        },
        {
        "type": "Other Loan",
        "amount": "00,000"
        }
    ];

const TotalAccounts = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    //const navigate = useNavigate();
    // const handleBackClick = () => {
    //     navigate(-1);
    // }
    return (
    <div className='font-sans h-full w-full mt-20'>
    {/* <div className='flex justify-start items-center'>
        <Link onClick={handleBackClick}>
            <div className='flex w-full justify-center items-center gap-2 my-2 mx-3 cursor-pointer text-black text-md hover:text-pretty'>
                <FaArrowLeftLong />
                Back
            </div>
        </Link>
    </div> */}
    <div className='flex flex-col justify-center items-center w-full my-5'>
        <div className='flex flex-col justify-center items-center h-fit w-[95%] bg-blue-100 rounded-lg p-2'>
            <div className='flex flex-col gap-2 justify-center w-full items-center my-4'>
                <p className='text-primary text-2xl font-semibold'>Total Accounts</p>
                <div className='flex flex-row justify-center items-center gap-2'>
                    <p className='text-xs text-black font-semibold'>11 Accounts</p>
                    <p className='text-[10px] text-green-500 font-semibold'>10 Active</p>
                    <p className='text-[10px] text-red-500 font-semibold'>00 Closed</p>
                </div>
            </div>
            <div className='flex flex-row justify-center items-center gap-0.5 mb-2 h-16 w-full'>
                <div className='w-[16%]  cursor-pointer' text-sm >
                    <div id='scorebar-0' className='bg-red-500 h-3 rounded-l-md' />
                </div>
                <div className='w-[8%] cursor-pointer' text-sm >
                    <div id='scorebar-1' className='bg-primary h-3'/>
                </div>
                
                <div className='w-[6%] cursor-pointer' text-sm >
                    <div id='scorebar-2' className='bg-text_color2  h-3' />
                </div>
                
                <div className='w-[6%] cursor-pointer' text-sm >
                    <div id='scorebar-3' className='bg-text_color3 h-3' />
                </div>

                <div className='relative w-[6%] cursor-pointer' text-sm  >
                    <div className='bg-text_color4 h-3 rounded-r-md'/>
                    <div className='flex flex-col items-center justify-start absolute top-100 -left-4 text-xs text-gray-500'>
                        <GoTriangleUp className='text-text_color4' />
                        <p className=''> Excellent </p>
                    </div>
                </div>
            </div>
            <div className='flex flex-row w-full justify-center items-center gap-4 mt-4 mb-6 h-20'>
                <div className='flex flex-col justify-center items-start gap-2 h-full w-[44%]'>
                    <p className='text-red-500 text-sm font-bold'>Loan EMI - 9,900.6</p>
                    <p className='text-xs'>Amount Payable- 5,94,036.0</p>
                </div>
                <div className='flex flex-col justify-center items-start gap-2 h-full w-[44%]'>
                    <p className='text-xs'>Loan Amount - 5,00,000</p>
                    <p className='text-xs'>Interest Amount - 94,036</p>
                </div>
            </div>
        </div>
        
        <div className='grid grid-cols-2 grid-rows-3 place-content-between place-items-center w-[95%] gap-3 my-3'>
            {
            loans.map((value,index)=>{
                return <div key={index} className='flex flex-col justify-around items-start w-full h-20 p-2 px-4 border border-primary rounded-lg'>
                    <p className='text-lg'>₹ {value.amount}</p>
                    <p className='text-xs text-gray-500'>{value.type}</p>
                </div>
            })
            }
        </div>
    </div>
    <p className='sr-only'>KGST</p>
    <Footer />
    </div>
    )
}

export default TotalAccounts